const IconBaby = props => (
	<svg
		width="8"
		height="12"
		viewBox="0 0 8 12"
		fill="none"
		aria-hidden="true"
		data-testid="icon-baby"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_2151_22054)" transform="translate(-1, 0)">
			<path
				d="M8.95508 3.81269C8.95508 1.70723 7.16079 -0.00549316 4.95508 -0.00549316C2.74936 -0.00549316 0.955078 1.70723 0.955078 3.81269C0.955078 4.5436 1.17222 5.25269 1.58365 5.86905C1.17222 6.51269 0.955078 7.24905 0.955078 8.00723C0.955078 10.2054 2.74936 12 4.95508 12C6.61222 12 8.07508 11.0072 8.68079 9.45814C8.86365 8.99451 8.95508 8.50905 8.95508 8.00723C8.95508 7.25451 8.73794 6.51269 8.32651 5.86905C8.73794 5.25269 8.95508 4.54905 8.95508 3.81269ZM4.95508 10.9036C3.37794 10.9036 2.09794 9.60542 2.09794 8.00178C2.09794 7.55996 2.19508 7.13451 2.39508 6.73632C2.88079 7.1236 3.44651 7.39632 4.05222 7.52723C4.64651 7.97451 5.97794 8.8636 7.38936 9.52905C6.87508 10.38 5.95508 10.9036 4.96079 10.9036H4.95508ZM4.95508 2.99451C5.34936 2.99451 5.72079 2.85814 6.01794 2.61814C6.13222 2.51996 6.20079 2.38905 6.21222 2.24178C6.22365 2.09451 6.17222 1.95814 6.07508 1.8436C5.97794 1.73451 5.83508 1.66905 5.68651 1.65814C5.53794 1.65269 5.38365 1.69632 5.26936 1.78905C5.18365 1.85996 5.07508 1.89814 4.96079 1.89814C4.70936 1.89814 4.50365 1.71269 4.50365 1.48905C4.50365 1.26542 4.70936 1.07996 4.96079 1.07996C6.53794 1.07996 7.81794 2.30178 7.81794 3.80723C7.81794 5.31269 6.53794 6.53451 4.96079 6.53451C3.38365 6.53451 2.10365 5.31269 2.10365 3.80723C2.10365 2.90723 2.57794 2.07269 3.36079 1.56542C3.40079 2.35632 4.10365 2.98905 4.96079 2.98905L4.95508 2.99451ZM7.52079 6.73632C7.71508 7.13451 7.81222 7.55996 7.81222 8.00178C7.81222 8.16542 7.80079 8.32905 7.77222 8.49269C7.09794 8.17087 6.46365 7.79996 5.98365 7.49451C6.54365 7.35269 7.06936 7.09087 7.52079 6.73087V6.73632Z"
				fill="currentColor"
			/>
			<path
				d="M6.10449 4.35959C6.41877 4.35959 6.67592 4.11413 6.67592 3.81413C6.67592 3.51413 6.41877 3.26868 6.09877 3.26868C5.77877 3.26868 5.52734 3.51413 5.52734 3.81413C5.52734 4.11413 5.78449 4.35959 6.09877 4.35959H6.10449Z"
				fill="currentColor"
			/>
			<path
				d="M3.81738 4.35959C4.13166 4.35959 4.38881 4.11413 4.38881 3.81413C4.38881 3.51413 4.13166 3.26868 3.81166 3.26868C3.49166 3.26868 3.24023 3.51413 3.24023 3.81413C3.24023 4.11413 3.49738 4.35959 3.81166 4.35959H3.81738Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2151_22054">
				<rect
					width="8"
					height="12.0055"
					fill="white"
					transform="translate(0.955078 -0.00549316)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default IconBaby;
